/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Markup

1 = Margin


 */
export type MarkupMarginPercentageTypes =
  (typeof MarkupMarginPercentageTypes)[keyof typeof MarkupMarginPercentageTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkupMarginPercentageTypes = {
  Markup: 0,
  Margin: 1,
} as const;
